<template>
  <ValidationObserver ref="form">
    <form @submit.prevent="">
      <h5 class="text-center">{{ lang.label }} Section</h5>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <ValidationProvider
            vid="title"
            rules=""
            name="The Title"
            v-slot="{ passed, failed,errors }">
            <fg-input type="text"
                      :error="failed ? errors[0]: null"
                      label="title"
                      name="title"
                      fou
                      v-model="formData.title">
            </fg-input>
          </ValidationProvider>
          <ValidationProvider
            vid="sub_title"
            rules=""
            name="The Sub Title"
            v-slot="{ passed, failed,errors }">
            <fg-input type="text"
                      :error="failed ? errors[0]: null"
                      label="Sub Title"
                      name="sub_title"
                      fou
                      v-model="formData.sub_title">
            </fg-input>
          </ValidationProvider>
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <ValidationProvider
                  vid="content_title"
                  rules=""
                  name="The Content Title"
                  v-slot="{ passed, failed,errors }">
                  <fg-input type="text"
                            :error="failed ? errors[0]: null"
                            label="Content Title"
                            name="content_title"
                            fou
                            v-model="formData.content_title">
                  </fg-input>
                </ValidationProvider>
              </div>
            </div>
            <label>Content</label>
            <editor
              v-model="formData.content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>

          <div class="col-md-12 com-sm-12 mb-2 mt-2">
            <div class="row d-flex justify-content-between">
              <div class="list-items">
                <label>Goals</label>
                <div class="col-12">
                  <template class="row" v-for="(goal,goalIndex) in formData.goals">
                    <fg-input type="text"
                              :label="'Goal '+(goalIndex+1)"
                              v-model="formData.goals[goalIndex]">
                    </fg-input>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeGoal(formData.goals, goalIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewGoal(formData.goals)"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
              <div class="list-items">
                <label>Courses</label>
                <div class="col-12">
                  <template class="row" v-for="(course,courseIndex) in formData.courses">
                    <fg-input type="text"
                              :label="'Course '+(courseIndex+1)"
                              v-model="formData.courses[courseIndex]">
                    </fg-input>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeGoal(formData.courses, courseIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewGoal(formData.courses)"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
              <div class="list-items">
                <label>Milestones</label>
                <div class="col-12">
                  <ValidationProvider
                    vid="milestones"
                    rules=""
                    name="The Milestones Title"
                    v-slot="{ passed, failed,errors }">
                    <fg-input type="text"
                              :error="failed ? errors[0]: null"
                              label="Milestones Title"
                              name="milestones"
                              fou
                              v-model="formData.milestones_title">
                    </fg-input>
                  </ValidationProvider>
                  <template class="row" v-for="(milestone, milestoneIndex) in formData.milestones">
                    <div class="col-md-10">
                      <fg-input type="text"
                                :key="milestoneIndex"
                                :label="'Milestone '+(milestoneIndex+1)"
                                v-model="formData.milestones[milestoneIndex].title">
                      </fg-input>
                    </div>
                    <div class="col-md-10">
                      <label class="card-label">Date</label>
                      <fg-input v-model="formData.milestones[milestoneIndex].date"
                                value-format="YYYY-MM-DD HH:MM:SS"
                                type="datetime-local"
                                placeholder="Chose milestone date"
                      >
                      </fg-input>
                    </div>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeMilestone(formData.milestones, milestoneIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewMilestone(formData.milestones, {title: '', date: ''})"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
              <div class="list-items">
                <label>Public Comments</label>
                <div class="col-12">
                  <template class="row" v-for="(item, itemIndex) in formData.public_comments">
                    <div class="col-md-10">
                      <fg-input type="text"
                                :key="itemIndex"
                                :label="'Text '+(itemIndex+1)"
                                v-model="formData.public_comments[itemIndex].title">
                      </fg-input>
                    </div>
                    <div class="col-md-10">
                      <label class="card-label">Content</label>
                      <editor
                        v-model="formData.public_comments[itemIndex].content"
                        :api-key="editorKey"
                        :init='editorConfig'
                      />
                    </div>
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removePublicComments(formData.public_comments, itemIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewPublicComments(formData.public_comments, {title: '', content: ''})"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-md-12 list-items list-partners">
                <label>Partners</label>
                <div class="col-12">
                  <template class="row" v-for="(partner,partnerIndex) in formData.partners">
                    <fg-input type="text"
                              :label="'Partner '+(partnerIndex+1)"
                              v-model="formData.partners[partnerIndex].name">
                    </fg-input>
                    <label>Details</label>
                    <editor
                      v-model="formData.partners[partnerIndex].details"
                      :api-key="editorKey"
                      :init='editorConfig'
                    />
                    <div class="col-sm-1 align-self-center mt-3">
                      <l-button
                        @click="removeGoal(formData.partners, partnerIndex)"
                        type="danger" size="sm">
                        <i class="fa fa-trash"></i>
                      </l-button>
                    </div>
                  </template>
                  <l-button
                    class="mt-3"
                    type="success"
                    @click="addNewPartner(formData.partners)"
                    size="sm">
                    <i class="fa fa-plus"></i>
                  </l-button>
                </div>
              </div>
            </div> -->
          </div>
          <label>Achievement</label>
          <editor
            v-model="formData.achievement"
            :api-key="editorKey"
            :init='editorConfig'
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ValidationProvider
            vid="gallery_title"
            rules=""
            name="The Gallery Title"
            v-slot="{ passed, failed,errors }">
            <fg-input type="text"
                      :error="failed ? errors[0]: null"
                      label="Gallery Title"
                      name="gallery_title"
                      fou
                      v-model="formData.gallery_title">
            </fg-input>
          </ValidationProvider>
        </div>
      </div>
      <div class="form-group">
        <label>Gallery</label>
        <el-tooltip placement="right" v-if="false">
          <div slot="content"></div>
          <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
        </el-tooltip>
        <multiple-file-uploader-file-manager
          :preview-width="'200px'"
          :preview-height="'200px'"
          v-model="formData.gallery"
          :files-number="30"
          :accepted-files="imagesExtensions">
        </multiple-file-uploader-file-manager>
      </div>

      <!-- // -->
      <div class="form-group">
        <label>PDF</label>
        <el-tooltip placement="right" v-if="false">
          <div slot="content"></div>
          <span style="margin: 0 5px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path
                    d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                </svg>
                </span>
        </el-tooltip>
        <multiple-file-uploader-file-manager
          :preview-width="'200px'"
          :preview-height="'200px'"
          v-model="formData.files"
          :files-number="30"
          :fileType="'document'"
          :accepted-files="pdfExtensions">
        </multiple-file-uploader-file-manager>
      </div>

      <div class="form-group" >
        <label>Videos</label>
        <el-tooltip placement="right" v-if="false">
          <div slot="content"></div>
          <span style="margin: 0 5px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                  <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                </svg>
                </span>
        </el-tooltip>
        <multiple-file-uploader-file-manager  :preview-width="'200px'"
                                            :preview-height="'200px'"
                                            :files-number="30"
                                            v-model="formData.videos"
                                            :accepted-files="videosExtensions">

        </multiple-file-uploader-file-manager>
      </div>
      <!-- /// -->
      <!--          //Links-->
      <div class="row">
        <div class="col-md-12">
          <label>Links</label>
          <div class="col-12">
            <template class="row" v-for="(listItem,listItemIndex) in formData.links">
              <div class="row team_list_items">
                <label>Item # {{ listItemIndex + 1 }}</label>
                <!--                list item title-->
                <div class="col-md-12">
                  <ValidationProvider
                    vid="en.linkstitle"
                    rules="required"
                    name="The Title"
                    v-slot="{ passed, failed,errors }">
                    <fg-input type="text"
                              :key="'title_'+listItemIndex"
                              :error="failed ? errors[0]: null"
                              :label="'Title '+(listItemIndex+1)"
                              v-model="formData.links[listItemIndex].title">
                    </fg-input>
                  </ValidationProvider>
                </div>
                <div class="col-md-12">
                  <ValidationProvider
                    vid="en.linkstype"
                    rules="required"
                    name="The Type"
                    v-slot="{ passed, failed,errors }">
                    <fg-select
                      name="linkstype"
                      size="large"
                      filterable
                      clearable
                      placeholder="Type"
                      :error="failed ? errors[0]: null"
                      :input-classes="'select-default'"
                      :label="'Type'"
                      :list="builderData.initiativeLinksType"
                      :listItemLabel="'label'"
                      :listItemValue="'value'"
                      v-model="formData.links[listItemIndex].type">
                    </fg-select>
                  </ValidationProvider>
                </div>
                <div class="col-md-12">
                  <ValidationProvider
                    vid="en.linkslinks"
                    rules="required"
                    name="The Link"
                    v-slot="{ passed, failed,errors }">
                    <fg-input type="text"
                              :key="'link_'+listItemIndex"
                              :error="failed ? errors[0]: null"
                              :label="'Link '+(listItemIndex+1)"
                              v-model="formData.links[listItemIndex].link">
                    </fg-input>
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-sm-1 align-self-center mt-3">
                <l-button
                  @click="removeItem(formData.links, listItemIndex)"
                  type="danger" size="sm">
                  <i class="fa fa-trash"></i>
                </l-button>
              </div>
            </template>
            <l-button
              class="mt-3"
              type="success"
              @click="addNewItem(formData.links, { title: '', type: '', link: ''})"
              size="sm">
              <i class="fa fa-plus"></i>
            </l-button>
          </div>
        </div>
      </div>

      <!--          //join section-->
      <div class="team_list_items">
        <label class="section_name">join section</label>
        <div class="row">
          <div class="col-md-12">
            <ValidationProvider
              vid="join_title"
              rules=""
              name="The Join Title"
              v-slot="{ passed, failed,errors }">
              <fg-input type="text"
                        :error="failed ? errors[0]: null"
                        label="Join Title"
                        name="join_title"
                        fou
                        v-model="formData.join_title">
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group">
          <label>Join Content</label>
          <editor
            v-model="formData.join_content"
            :api-key="editorKey"
            :init='editorConfig'
          />
        </div>
        <!-- //extra sections  -->

    <div class="row">
            <div class="col-md-12">
              <label>Extra Sections</label>
              <div class="col-12">
                <template class="row" v-for="(listItem,listItemIndex) in formData.join_extra_sections">
                  <div class="row team_list_items">
                    <label>Item # {{ listItemIndex + 1 }}</label>
                    <!--                list item title-->
                    <div class="col-md-12">
                      <ValidationProvider
                        vid="EStitle"
                        rules="required"
                        name="The Title"
                        v-slot="{ passed, failed,errors }">
                        <fg-input type="text"
                                  :key="'title_'+listItemIndex"
                                  :error="failed ? errors[0]: null"
                                  :label="'Title '+(listItemIndex+1)"
                                  v-model="formData.join_extra_sections[listItemIndex].title">
                        </fg-input>
                      </ValidationProvider>
                    </div>
                    <div class="form-group">
                    <label>Content {{(listItemIndex+1)}}</label>
                    <editor
                      v-model="formData.join_extra_sections[listItemIndex].content"
                      :api-key="editorKey"
                      :init='editorConfig'
                    />
                  </div>

                  </div>
                  <div class="col-sm-1 align-self-center mt-3">
                    <l-button
                      @click="removeItem(formData.join_extra_sections, listItemIndex)"
                      type="danger" size="sm">
                      <i class="fa fa-trash"></i>
                    </l-button>
                  </div>
                </template>
                <l-button
                  class="mt-3"
                  type="success"
                  @click="addNewItem(formData.join_extra_sections, { title: '', content: ''})"
                  size="sm">
                  <i class="fa fa-plus"></i>
                </l-button>
              </div>
            </div>
          </div>

    <!-- //end extra sections  -->

    <div class="form-group pt-4">
          <label>Extra Info</label>
          <editor
            v-model="formData.extra_info"
            :api-key="editorKey"
            :init='editorConfig'
          />
        </div>

        <!--          //Final Report-->
        <div class="team_list_items">
          <label class="section_name">Final Report</label>
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="final_report_main_title"
                rules=""
                name="The Final Report Main Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Final Report Main Title"
                          name="final_report_main_title"
                          fou
                          v-model="formData.final_report_main_title">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ValidationProvider
                vid="final_report_title"
                rules=""
                name="The Final Report Title"
                v-slot="{ passed, failed,errors }">
                <fg-input type="text"
                          :error="failed ? errors[0]: null"
                          label="Final Report Title"
                          name="final_report_title"
                          fou
                          v-model="formData.final_report_title">
                </fg-input>
              </ValidationProvider>
            </div>
          </div>
          <div class="form-group">
            <label>Final Report Content</label>
            <editor
              v-model="formData.final_report_content"
              :api-key="editorKey"
              :init='editorConfig'
            />
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Final Report Executive Summary</label>
                <el-tooltip placement="right" >
                  <div slot="content"> (548 * 548)</div>
                  <span style="margin: 0 5px;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                             class="bi bi-question-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path
                        d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                    </svg>
                    </span>
                </el-tooltip>
                <single-file-uploader-file-manager
                  :preview-width="'200px'"
                  :preview-height="'200px'"
                  v-model="formData.final_report_executive_summary"
                  :fileType="'document'"
                  :accepted-files="pdfExtensions">
                </single-file-uploader-file-manager>
              </div>
            </div>
          </div>
          <!--          //Keywords-->
          <div class="row">
            <div class="col-md-12">
              <label>Keywords</label>
              <div class="col-12">
                <template class="row" v-for="(listItem,listItemIndex) in formData.final_report_keywords">
                  <div class="row team_list_items">
                    <label>Item # {{ listItemIndex + 1 }}</label>
                    <!--                list item title-->
                    <div class="col-md-12">
                      <ValidationProvider
                        vid="en.linkstitle"
                        rules="required"
                        name="The Title"
                        v-slot="{ passed, failed,errors }">
                        <fg-input type="text"
                                  :key="'title_'+listItemIndex"
                                  :error="failed ? errors[0]: null"
                                  :label="'Title '+(listItemIndex+1)"
                                  v-model="formData.final_report_keywords[listItemIndex].title">
                        </fg-input>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-sm-1 align-self-center mt-3">
                    <l-button
                      @click="removeItem(formData.final_report_keywords, listItemIndex)"
                      type="danger" size="sm">
                      <i class="fa fa-trash"></i>
                    </l-button>
                  </div>
                </template>
                <l-button
                  class="mt-3"
                  type="success"
                  @click="addNewItem(formData.final_report_keywords, { title: ''})"
                  size="sm">
                  <i class="fa fa-plus"></i>
                </l-button>
              </div>
            </div>
          </div>
          <!-- /// -->
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
  import { Select, Option, Tooltip } from 'element-ui'
  import { extend } from "vee-validate";
  import { required, email, regex } from "vee-validate/dist/rules";
  import Editor from '@tinymce/tinymce-vue'
  import FormGroupTextArea from "@/components";
  import MultipleFileUploaderFileManager from "../../../components/FileManager/MultipleFileUploaderFileManager";
  import FgSelect from "../../../components/Inputs/formGroupSelect";
  import SingleFileUploaderFileManager from "../../../components/FileManager/SingleFileUploaderFileManager";

  extend("required", required);
  extend("email", email);
  extend("regex", regex);

  export default {
    components: {
      SingleFileUploaderFileManager,
      FgSelect,
      [Tooltip.name]: Tooltip,
      MultipleFileUploaderFileManager,
      FormGroupTextArea,
      [Select.name]: Select,
      [Option.name]: Option,
      'editor': Editor
    },
    props: {
      lang: {
        type: Object
      },
      editMode: {
        type: Boolean,
        default: false
      },
      isSubmit: {
        type: Boolean,
        default: false
      },
      builderData:{},
      formData:{
        type: Object,
        default() {
          return {
            title: "",
            sub_title: "",
            goals: [],
            content: "",
            partners: [],
            news: [],
            courses: [],
            content_title: '',
            achievement: '',
            milestones_title: '',
            milestones: [],
            gallery: [],
            gallery_title: '',
            files: [],
            videos: [],
            links: [],
            join_extra_sections: [],
            extra_info: '',
            public_comments: [],
            final_report_title: '',
            final_report_content: '',
            final_report_main_title: '',
            final_report_keywords: [],
            final_report_executive_summary: '',
          }
        }
      },
    },
    data () {
      return {
        editorConfig: this.getEditorConfig(),
        editorKey: process.env.VUE_APP_TINY_EDITOR_KEY,
        milestoneObject: {
          title: '',
          date: '',
        },
        imagesExtensions: this.getImagesExtensions(),
        pdfExtensions: this.getPdfExtensions(),
        videosExtensions: this.getVideoExtensions(),
      }
    },
    methods: {
      validate() {
        return this.$refs.form.validate().then(res => {
          if (res){
            this.$emit('submit-step', this.formData, this.lang.value, this.isSubmit)
          }else{
            this.$emit('on-validated', res)
          }
          return res
        });
      },
      addNewGoal(goals) {
        goals.push('');
      },
      addNewPartner(partner) {
        partner.push({name: '', details: ''});
      },
      removeGoal(goals, index) {
        goals.splice(index, 1);
      },
      addNewMilestone(milestones, listObject){
        milestones.push(listObject);
      },
      removeMilestone(milestones, index) {
        milestones.splice(index, 1);
      },
      addNewItem(listItems, initObject) {
        listItems.push(initObject);
      },
      removeItem(listItems, index) {
        listItems.splice(index, 1);
      },
      addNewPublicComments(item, listObject){
        item.push(listObject);
      },
      removePublicComments(item, index) {
        item.splice(index, 1);
      },
    }
  }
</script>
<style>
.team_list_items{
  border: 1px solid #cccc;
  padding: 10px 45px 30px 19px;
}
.team_list_items .section_name {
  position: relative;
  top: -20px;
  left: 20px;
  background-color: #fff;
  padding: 0 10px;
}
</style>
